import React, { useContext, useEffect, useState } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import DateForm from "../../../Components/DateForm/DateForm";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { useLocation } from "react-router-dom";
import notify from "../../../Helpers/ToastNotification";
import { APICall, HttpMethod } from "../../../Helpers/Network/APICalls";
import { getPersonalDetailsByMemberId } from "../../../Helpers/APIEndPoints/EndPoints";
import moment from "moment";
import { truncate } from "fs";
import { GetDecryptedMemberIdFromLocalStorage } from "../../../Helpers/CommonFunctions/EncryptedMemberIdFunction";

const PersonalDetails = () => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  // const memberid = GetDecryptedMemberIdFromLocalStorage() || "";
  const { state } = useLocation();
  const memberid = state.id ? state.id : "";
 

  const [data, setData] = React.useState({
    tokenNumber: null,
    typeOfApplicant: null,
    firstName: "",
    middleName: "",
    lastName: "",
    dob: null,
    doj: null,
    doc: null,
    mobileNumber: null,
    email: "",
    address: "",
  });

  const [error, setError] = React.useState<any>({});

  const TypeofApplicantDropDownData = [
    { value: 1, label: "Officers, M&M and Core Users (Mahindra)" },
    { value: 2, label: "Staff, Workmen and Other Companies (Other)" },
  ];

  const tabsData = TypeofApplicantDropDownData;

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  const getPersonalDetailsByIdApiCall = async (memberid: any) => {
    showLoader();

    // let param = `${getPersonalDetailsByMemberId}/${id}`;

    // const res = await APICall(param, {}, HttpMethod.GET);

    let requestParams = { MemberId: memberid };
    const res = await APICall(getPersonalDetailsByMemberId, requestParams);

    if (res.Message === "Ok" && res.Data !== null) {
      let data = {
        tokenNumber: Number(res.Data.TokenNo),
        typeOfApplicant: tabsData.find(
          (d) => d.value === res.Data.ApplicantType
        ),
        firstName: res.Data.FirstName,
        middleName: res.Data.MiddleName,
        lastName: res.Data.LastName,
        dob: moment(res.Data.DOB, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
        doj: moment(res.Data.DOJ, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
        doc: moment(res.Data.DOC, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
        mobileNumber: Number(res.Data.ContactNo),
        email: res.Data.EmailId,
        address: res.Data.Address,
      };
      setData(data);
      hideLoader();
    } else {
      notify(1, "Data not found");
      hideLoader();
    }
  };

  const onLoadApiCall = async () => {
    showLoader();

    if (memberid != null && memberid != "") {
      await getPersonalDetailsByIdApiCall(memberid);
    } else {
      notify(1, "Something went wrong");
    }

    hideLoader();
  };

  useEffect(() => {
    onLoadApiCall();
  }, []);

  return (
    <div className="">
      <div className="col-lg-12 col-md-12 p-0">
        <div className="row" style={{ marginLeft: "-30px", marginRight: "-30px"}}>
          <div
            className="col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-center "
            style={{ marginTop: "15px", background: "#F6ECED" }}
          > <div
          className="col-lg-4 col-sm-4 col-xs-4 "
          style={{
            marginTop: "15px",
            background: "#F6ECED",
            padding: "15px",
          }}
        >
          <div className="form-group">
            <label>Token Number</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.tokenNumber}
              maxlength="10"
              isDisabled={true}
              type="number"
              onWheel={(e) => e.target.blur()}
            />
            {error[data.tokenNumber] && (
              <p style={{ color: "red" }}>{error[data.tokenNumber]}</p>
            )}
          </div>
        </div>

          </div>
         </div>
         <div className="row">
          
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Type of Applicant</label>
            <sup>*</sup>
            <SelectForm
              value={data.typeOfApplicant}
              isDisabled={true}
              placeholder="Type Of Applicant"
              options={tabsData}
              onChange={(val: any) => onChange("typeOfApplicant", val)}
            />
            {error[data.typeOfApplicant] && (
              <p style={{ color: "red" }}>{error[data.typeOfApplicant]}</p>
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>First Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.firstName}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("firstName", value);
              }}
            />
            {error[data.firstName] && (
              <p style={{ color: "red" }}>{error[data.firstName]}</p>
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Middle Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.middleName}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("middleName", value);
              }}
            />
            {error[data.middleName] && (
              <p style={{ color: "red" }}>{error[data.middleName]}</p>
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Last Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.lastName}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("lastName", value);
              }}
            />
            {error[data.lastName] && (
              <p style={{ color: "red" }}>{error[data.lastName]}</p>
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date Of Birth</label>
            <sup>*</sup>
            <DateForm
              isDisabled={true}
              value={data.dob}
              onChange={(val: any) => onChange("dob", val)}
              placeholder="DD-MM-YYYY"
            />
            {error[data.dob] && (
              <p style={{ color: "red" }}>{error[data.dob]}</p>
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date of Joining</label>
            <sup>*</sup>
            <DateForm
              isDisabled={true}
              value={data.doj}
              onChange={(val: any) => onChange("doj", val)}
              placeholder="DD-MM-YYYY"
            />
            {error[data.doj] && (
              <p style={{ color: "red" }}>{error[data.doj]}</p>
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date of Confirmation</label>
            <sup>*</sup>
            <DateForm
              isDisabled={true}
              value={data.doc}
              onChange={(val: any) => onChange("doc", val)}
              placeholder="DD-MM-YYYY"
            />
            {error[data.doc] && (
              <p style={{ color: "red" }}>{error[data.doc]}</p>
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Mobile Number</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.mobileNumber}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                const regex = /^[0-9\b]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 10) {
                    value = value.slice(0, 10);
                  }
                  onChange("mobileNumber", value);
                }
              }}
              type="number"
              onWheel={(e) => e.target.blur()}
            />
            {error[data.mobileNumber] && (
              <p style={{ color: "red" }}>{error[data.mobileNumber]}</p>
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Email Id</label>
            <InputForm
              placeholder={""}
              value={data.email}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("email", value);
              }}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Address</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.address}
              isDisabled={true}
              textArea={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("address", value);
              }}
            />
            {error[data.address] && (
              <p style={{ color: "red" }}>{error[data.address]}</p>
            )}
          </div>
        </div>
      </div>
      {/* <div className="p-2 d-flex justify-content-end" style={{ marginTop: 50 }}>
        <ButtonComponent  icon={"fas fa-arrow-right"} value={"Save & Next" } style={{marginLeft:"10px"}}  id={"saveBtn"} onClick={onSubmit}/>
      </div> */}
    </div>
  );
};

export default PersonalDetails;
